// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Webcam styles */
.webcam-view {
  width: 100%;
  height: auto;
  display: block;
}

/* Card frame animation */
@keyframes pulse {
  0% {
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
  }
  50% {
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.5);
  }
  100% {
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
  }
}

.border-white {
  animation: pulse 2s infinite;
}

/* Bootstrap theme overrides for better dark mode */
.bg-secondary {
  background-color: #2b2b2b !important;
}

.border-2 {
  border-width: 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Scan.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,mDAAmD;AACnD;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["/* Webcam styles */\n.webcam-view {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Card frame animation */\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);\n  }\n  50% {\n    box-shadow: 0 0 30px rgba(255, 255, 255, 0.5);\n  }\n  100% {\n    box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);\n  }\n}\n\n.border-white {\n  animation: pulse 2s infinite;\n}\n\n/* Bootstrap theme overrides for better dark mode */\n.bg-secondary {\n  background-color: #2b2b2b !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
